export default __webpack_public_path__ + "media/images/ball-splat-560c3bd97d1d3c2154d26d01de3e6048.svg";